import type { PhotoDto } from '@camper-diary/shared';
import { api, HttpError } from './client';

export type Photo = PhotoDto;

export function listPhotos(tripId: string) {
  return api<Photo[]>(`/trips/${encodeURIComponent(tripId)}/photos`);
}

/**
 * Upload una singola foto. Throwa HttpError se il backend rifiuta.
 * Il file MUST essere un'immagine: validazione magic-byte lato server.
 */
export async function uploadPhoto(tripId: string, file: File): Promise<Photo> {
  const fd = new FormData();
  fd.append('file', file, file.name);
  return api<Photo>(`/trips/${encodeURIComponent(tripId)}/photos`, {
    method: 'POST',
    body: fd,
  });
}

export function deletePhoto(id: string) {
  return api<null>(`/photos/${encodeURIComponent(id)}`, { method: 'DELETE' });
}

export function updatePhotoCaption(id: string, caption: string | null) {
  return api<Photo>(`/photos/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    body: { caption },
  });
}

export { HttpError };
